import axios from 'axios';
import {
  createContext,
  useState,
  useEffect,
  useRef,
  PropsWithChildren,
} from 'react';

interface CourseCategories {
  id: number;
  title: string;
  slug: string;
  summary: string;
  image_url: string;
}

interface ServiceCategories {
  title: string;
  slug: string;
}

interface ShoppeCategories {
  name: string;
  slug: string;
  categories: {
    name: string;
    slug: string;
    sub_categories: {
      name: string;
      slug: string;
    }[];
  }[];
}

interface PaymentMethod {
  name: string;
  qr_code: string;
  upi_id: string;
}

interface Branch {
  name: string;
}

interface CategoryContext {
  courses: CourseCategories[];
  services: ServiceCategories[];
  shoppe: ShoppeCategories[];
  branches: Branch[];
  paymentMethods: PaymentMethod[];
  /** The advertised number, rendered by the brand rule above the footer. */
  phone: string | null;
}
const intialValue = {
  courses: [],
  services: [],
  shoppe: [],
  branches: [],
  paymentMethods: [],
  phone: null,
};

// Create a context
export const CategoryContext = createContext<CategoryContext>(intialValue);

// Context provider component
export const CategoryProvider = ({ children }: PropsWithChildren) => {
  const [categories, setCategories] = useState<CategoryContext>(intialValue);
  const hasFetched = useRef(false);

  useEffect(() => {
    // Guards against StrictMode's dev-only double-invoke firing this POST twice.
    if (hasFetched.current) {
      return;
    }
    hasFetched.current = true;
    void fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.post('/api/categories');
      setCategories({ ...response.data } as CategoryContext);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  return (
    <CategoryContext.Provider value={categories}>
      {children}
    </CategoryContext.Provider>
  );
};
